import { LIFormFieldValues, LOFormFieldValues } from '@/domain/job-application/types';

import { fieldsToParse, formFieldLabelByName } from './constants';
import { getDialCodeFromCountryCode } from './country-codes';

type FormFieldValues = LIFormFieldValues | LOFormFieldValues;

const getParsedField = (formFieldValues: FormFieldValues, fieldName: (typeof fieldsToParse)[number]) => {
  switch (fieldName) {
    case 'phone':
      return formFieldValues.phone
        ? {
            label: formFieldLabelByName.phone,
            value: [`+${getDialCodeFromCountryCode(formFieldValues.countryCode)}${formFieldValues.phone}`],
          }
        : undefined;
    case 'otherDocs':
      return formFieldValues.otherDocs
        ? {
            label: formFieldLabelByName.otherDocs,
            value: formFieldValues.otherDocs.split(','),
          }
        : undefined;
    default:
      return formFieldValues[fieldName]
        ? {
            label: formFieldLabelByName[fieldName],
            value: [formFieldValues[fieldName]],
          }
        : undefined;
  }
};

export function getParsedFormData(formFieldValues: FormFieldValues) {
  return fieldsToParse.map((fieldName) => getParsedField(formFieldValues, fieldName)).filter(Boolean);
}
